
import Vue from 'vue';
import Component from 'vue-class-component';
import {Watch} from 'vue-property-decorator';
import {CourseRecord, LessonRecord} from '../student-program';

@Component({
	props: ['rec'],
	data: function() {
		return {
			hoveredLesson: null,
		};
	}
})
export default class CourseTile extends Vue {
	hoveredLesson:LessonRecord|null;

	hoverLesson(lr:LessonRecord|null) {
		console.log('setting hovered lesson to', lr);
		this.hoveredLesson = lr;
	}

	get toLink() {
		if (this.$route.params.courseId) {
			return {name: 'courseLessonNav', params:{}};
		} else {
			let params = {'courseId': this.rec.courseId};
			if (this.hoveredLesson) {
				params.lessonId = this.hoveredLesson.lessonId;
				params.skipped = '-';
			}
			return {name: 'courseLessonNav', params};
		}
	}
}
